export default __webpack_public_path__ + "static/media/gallery-wip-pommel_01.9aac2a88.jpg";